import { createContext, useContext, useReducer } from 'react'
import { initialModule, moduleReducer } from '../../reducers/moduleReducer'

const ModuleContext = createContext()

export const ModuleProvider = ({ children }) => {
  const [modules, dispatch] = useReducer(moduleReducer, initialModule)

  return <ModuleContext.Provider value={{ modules, dispatch }}>{children}</ModuleContext.Provider>
}

export function useModule() {
  return useContext(ModuleContext)
}
